import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function FolderOpen({ color = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox="0 0 18 18" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2244 7.21982H9.47687C9.17969 7.21986 8.90213 7.07141 8.7372 6.8242L7.48989
        4.94925C7.32464 4.70091 7.04585 4.552 6.74756 4.55274H2.77805C1.79606 4.55274 1
        5.3488 1 6.33079V15.2211C1 16.2031 1.79606 16.9991 2.77805 16.9991H15.2244C16.2064
        16.9991 17.0025 16.2031 17.0025 15.2211V8.99787C17.0025 8.01588 16.2064 7.21982
        15.2244 7.21982Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill='transparent'
      />
      <Path
        d="M2.77734 4.55611V2.77805C2.77734 1.79606 3.57341 1 4.5554 1H13.4457C14.4277 1 15.2237
        1.79606 15.2237 2.77805V7.22319"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill='transparent'
      />
    </IconBase>
  )
}

FolderOpen.propTypes = {
  color: PropTypes.string,
}

export default FolderOpen
